routes.$inject = ['$routeProvider'];

export default function routes($routeProvider) {
  $routeProvider
    .when('/download', {
      template: require('./download.html'),
      controller: 'DownloadCtrl',
      app: true,
      resolve: {
        os: function () {
          var p = navigator.platform.toLowerCase();
          var os = '';
          if (p.indexOf('mac') !== -1) {
            os = 'mac';
          } else if (p.indexOf('win') !== -1) {
            os = 'windows';
          }
          return os;
        }
      }
    });
}



// WEBPACK FOOTER //
// ./project/pages/download/download.routes.js